import { AngularComponent } from '../../angular-core';
import { HttpService } from '../../services/http.service';

//グローバルから参照
declare const masonry_update_event: any;
declare const masonry_layout_event: any;

/**
 * 投稿の非同期読み込み (タイムテーブル)
 */
@AngularComponent({
  bindings: {},
  template: require('./async-event.component.html'),
  styles: require('./async-event.component.scss')
})
export class AsyncEventComponent {

  /**
   * アイテム
   */
  public items: any = [];

  /**
   * 現在のページ数
   */
  public paged: number = 1;

  /**
   * リクエストパラメータ
   */
  private readonly params: {[name: string]: string | number};

  /**
   * アイテムセレクター
   */
  private readonly item: string;

  /**
   * アイテムセレクター
   */
  private readonly $trigger: JQuery;

  /**
   * 総投稿数
   */
  private foundPosts: number = 0;

  /**
   * コンストラクタ
   */
  constructor(
    private readonly $scope: any,
    private readonly httpService: HttpService
  ) {
    this.params = {
      mode: 'found_posts',
      post_type: 'timetable'
    };
    this.item = '.fn-asyncItem';
    this.$trigger = $('.fn-asyncTrigger');
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    this.httpService.post(this.params)
    .then((response: any): void => {
      if (! response || ! response.data) {
        return;
      }

      this.foundPosts = response.data.found_posts;

      if ($(this.item).length >= this.foundPosts) {
        this.$trigger.hide();
      } else {
        this.$trigger.on('click', this.triggerListener);
      }
    })
    .catch((error: any): void => {});
  }

  /**
   * トリガーのクリックイベント
   */
  private triggerListener = (): void => {
    this.$trigger.hide();
    this.params['mode'] = 'get';
    this.params['paged'] = ++this.paged;

    this.httpService.post(this.params)
    .then((response: any): void =>{
      if (! response || ! response.data) {
        return;
      }

      for (let data of response.data) {
        this.items.push(data);
      }

      this.$scope.$watch('$ctrl.items', (newValue: any, oldValue: any): void => {
        this.invervalListener();
      });
    })
    .catch((error: any): void => {});
  }

  /**
   * インターバルリスナー
   */
  private invervalListener(): void {
    let intervalID: any = setInterval((): void => {
      const selector: string = `${this.item}[data-paged="${this.paged}"]`;
      const inner: string = `${this.item}__inner`;

      if ($(selector)[0]) {
        clearInterval(intervalID);
        $(selector).animate({opacity: 1}, 300);
        $(selector).find(inner).each((index: number, element: Element): void => {
          const $target = $(element);

          if (! $target.attr('data-hover')) {
            $target.attr('data-hover', 'true');

            if ($(window).width() > 999 && ! $('html').hasClass('ipad')) {
              $target.hover((event: JQueryEventObject): void => {
                $(event.currentTarget).find('.u-reverseToggle').toggleClass('is-hover');
              });
            } else {
              $target.find('.u-reverseToggle').addClass('is-hover');
            }

            try {
              masonry_update_event($target);
              masonry_layout_event();
            } catch (e) {}
          }
        });

        setTimeout((): void => {
          try {
            masonry_layout_event();
          } catch (e) {}
        }, 500);

        if ($(this.item).length < this.foundPosts) {
          this.$trigger.show();
        } else {
          this.$trigger.hide();
        }
      }
    }, 10);
  }

}
